module.exports = __webpack_public_path__ + "static/media/Logo_dark.6a119ab9.png";